import { LOGOUT, USERS } from "@constants/routes";
import UserContext from "@context/UserContext";
import PropTypes from "prop-types";
import { MouseEventHandler, ReactElement, useContext, useState } from "react";
import { TUserContext } from "types/Core/Authentication/userContext";
import SidebarCategory from "../SidebarCategory";
import SidebarLink from "../SidebarLink";
import Modules from "./Modules/Modules";

interface ISidebarContent {
  onClick: MouseEventHandler<HTMLAnchorElement>;
  sidebarCollapse?: boolean;
}

const SidebarContent = ({
  onClick,
  sidebarCollapse = false,
}: ISidebarContent): ReactElement => {
  const { HandleLogout } = useContext<TUserContext>(UserContext);
  const [isOpen, setIsOpen] = useState("");

  return (
    <div className="sidebar__content">
      <Modules
        onClick={onClick}
        sidebarCollapse={sidebarCollapse}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      <ul className="sidebar__block">
        <SidebarCategory
          icon={"lock"}
          title={"Security"}
          sidebarCollapse={sidebarCollapse}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        >
          <SidebarLink
            title={"Users"}
            route={USERS}
            onClick={onClick}
            dataTestId="security-users"
          />
        </SidebarCategory>
      </ul>

      <ul className="sidebar__block">
        <SidebarLink
          title={"Log out"}
          icon="exit"
          onClick={HandleLogout}
          route={LOGOUT}
          dataTestId="log-out"
        />
      </ul>
    </div>
  );
};

SidebarContent.propTypes = {
  onClick: PropTypes.func.isRequired,
  sidebarCollapse: PropTypes.bool,
};

export default SidebarContent;
